const RadioButton = ({
  data = {},
  wrapperClassName = "",
  radioClassName = "",
  value = "",
  selected = () => {},
  disabled = false,
}) => {
  function change(e) {
    selected(e.target.id);
  }
  return (
    <div className={`form-group radio-button ${wrapperClassName}`}>
      <div className="radio-header mb-2 fw-bold">{data?.header}</div>
      <div className={`${radioClassName}`}>
        {data?.data?.map((e, index) => {
          return (
            <div key={`${e.id || e.name}-${index}`}>
              <div className="form-check me-4 mb-2">
                <input
                  className="form-check-input"
                  type="radio"
                  name={e.name + "-" + index}
                  id={e.id}
                  checked={e.id == value.toString()}
                  onChange={change}
                  disabled={disabled || e.disabled}
                  aria-label={e.label}
                />
                <label
                  className="fw-normal"
                  htmlFor={e.name + "-" + index}
                  onClick={() => selected(e.id)}
                >
                  {e.label}
                </label>
              </div>
              {e.description && (
                <div className="small ms-4 mb-2">{e.description}</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RadioButton;
